import React from "react";
import { TooltipProps } from "recharts";
import styled from "styled-components";

interface DataPayload {
  date: string;
  close: string;
  price: number;
  percentage: number;
}

const TooltipContainer = styled.div`
  display: flex;
  font-size: 1rem;
  font-weight: 400;
  font-family: Roboto Condensed;
  item-align: center;
  text-align: center;
  background-color: #eaeaea;
  padding: 1rem;
  line-height: 1rem;
  border: 1px solid #eaeaea;
  font-size: 1rem;
  border-radius: 0.5rem;
`;

const Price = styled.p`
  text-align: left;
  padding-right: 0.2rem;
  margin-right: 0.2rem;
  padding-bottom: 0.25rem;
`;

const FormattedDate = styled.p`
  text-align: right;
  padding-left: 0.2rem;
  margin-left: 0.2rem;
  padding-bottom: 0.25rem;
`;

const formatDate = (dateString: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "short",
    year: "numeric",
  };
  return new Date(dateString).toLocaleDateString("en-GB", options);
};

const CustomTooltip = ({ active, payload }: TooltipProps<string, string>) => {
  if (active && payload && payload.length) {
    const data: DataPayload = payload[0].payload;
    const formattedDate = formatDate(data.date);

    return (
      <TooltipContainer className="custom-tooltip">
        <Price>₹{data.close}</Price> |
        <FormattedDate>{formattedDate}</FormattedDate>
      </TooltipContainer>
    );
  }
  return null;
};

export default CustomTooltip;
